import { ReferenceType } from '@/interfaces/grpc.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';

import getDealership from './getDealership';

const getDealershipId = (settings: ISettings, locations?: Array<ReferenceType>) => {
  const dealershipLocation = getDealership(settings, locations);
  return dealershipLocation?.id;
};

export default getDealershipId;
